import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_18: FaireProductEntity = {
  token: "atc_fs_18",
  type: "product",
  name: "Cookie Dough Protein Bar",
  brandName: "TruBar",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/468d9c2a8c7610b8cd2a19c5b8405ea6d2f2c93e4ca6ea38f62eb3f414001ff4.webp",
  priceDollars: 8,
  msrpDollars: 16,
  description: "ATC migration seed product",
  tags: ["food", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
